import * as React from 'react';
import { LabelText } from '@workday/canvas-kit-react/text';
import { createComponent } from '@workday/canvas-kit-react/common';
import { PaginationContext } from '../usePaginationModel';
export const GoToLabel = createComponent('label')({
    displayName: 'Pagination.GoToLabel',
    Component({ children, ...elemProps }, ref, Element) {
        const model = React.useContext(PaginationContext);
        return (React.createElement(LabelText, Object.assign({ ref: ref, as: Element, typeLevel: "subtext.medium", variant: "hint", whiteSpace: "nowrap" }, elemProps), typeof children === 'function' ? children(model) : children));
    },
});
